import axios, { buildApi } from '@/libs/api.request';
let name = '/report/gcc/'

export const apis = buildApi({
  get: [name + 'top', name + 'agent'],
})